import React, { useState, useEffect } from "react";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import Checkbox from "@mui/material/Checkbox";
import { Tooltip } from "@mui/material";
import Switch from "@mui/material/Switch";
import List from "@mui/material/List";
import CircularProgress from "@mui/material/CircularProgress";
import ListItem from "@mui/material/ListItem";
import GetAppIcon from "@mui/icons-material/GetApp";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemButton from "@mui/material/ListItemButton";
import { Modal, Button, Spinner } from "react-bootstrap";
import ListItemText from "@mui/material/ListItemText";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import ListItemIcon from "@mui/material/ListItemIcon";
import Typography from "@mui/material/Typography";
import axios from "axios";
const excel = [
  { name: "First Name", column: "first_name", isChecked: false },
  { name: "Middle Name", column: "middle_name", isChecked: false },
  { name: "Last Name", column: "last_name", isChecked: false },
  { name: "Phone Number", column: "phone_number", isChecked: false },
  { name: "WhatsApp Number", column: "whatsapp_number", isChecked: false },
  { name: "Email", column: "email", isChecked: false },
  { name: "State", column: "state_name", isChecked: false },
  { name: "District", column: "district_name", isChecked: false },
  { name: "Taluka", column: "taluka_name", isChecked: false },
  { name: "Village", column: "village_name", isChecked: false },
  { name: "Branch Name", column: "branch_name", isChecked: false },
  { name: "Category", column: "enquiry_category_name", isChecked: false },
  { name: "Sales Person", column: "sales_person_name", isChecked: false },
  {
    name: "Sales Person Number",
    column: "sales_person_number",
    isChecked: false,
  },
  { name: "Make Name", column: "manufacturer_name", isChecked: false },
  { name: "Model Name", column: "new_modal", isChecked: false },
  { name: "Chassis Name", column: "chassis_no", isChecked: false },
  { name: "Engine Name", column: "engine_no", isChecked: false },
  {
    name: "New Tractor Price",
    column: "new_tractor_price",
    isChecked: false,
  },
  {
    name: "Old Tractor Price",
    column: "old_tractor_price",
    isChecked: false,
  },
  { name: "Remaining Price", column: "remaining_price", isChecked: false },
  { name: "Payment Method", column: "payment_mode", isChecked: false },
  { name: "Bank Name", column: "bankname", isChecked: false },
  { name: "Enquiry Date", column: "enquiry_created_date", isChecked: false },
  { name: "Expected Delivery", column: "delivery_date", isChecked: false },
  {
    name: "Primary Source",
    column: "enquiry_primary_sources",
    isChecked: false,
  },
  { name: "Enquiry Source", column: "enquiry_sources", isChecked: false },
  { name: "Visit Reason", column: "visit_reason", isChecked: false },
  { name: "Company Name", column: "company_name", isChecked: false },
  { name: "Stage Name", column: "stage_name", isChecked: false },
  { name: "Enquiry Stage", column: "enquiry_stage", isChecked: false },
  { name: "Created By", column: "created_by", isChecked: false },
  { name: "Old Tractor", column: "old_details", isChecked: false },
  { name: "Follow Up Details", column: "followup_details", isChecked: false },
  { name: "Retail Date", column: "retail_date", isChecked: false },
  { name: "Delivery Create Date", column: "created_at", isChecked: false },
  {
    name: "Last Followup Date",
    column: "last_followup_date",
    isChecked: false,
  },
  {
    name: "Last Followup Person",
    column: "last_followed_person",
    isChecked: false,
  },
  {
    name: "Next Followup Date",
    column: "next_followup_date",
    isChecked: false,
  },
];
function SimpleDialog(props) {
  const {
    onClose,
    open,
    selectedType,
    selectedDates,
    excelKey,
    category,
    excelColumns,
  } = props;

  const [selectedColumns, setSelectedColumns] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [columns, setColumns] = React.useState(excelColumns);
console.log(excelColumns,"excelColumns.........!!!!")
  const fetchColumns = async (excelKey) => {
    const url = `${process.env.REACT_APP_NODE_URL}/api/generate/getColumns/${excelKey}`;
    const token = await localStorage.getItem("rbacToken");

    const config = {
      headers: {
        token: token ? token : "",
      },
    };

    try {
      const response = await axios.get(url, config);

      if (response.data.success) {
        const savedColumns = response.data.columns || [];

        // Only keep columns that exist in the current excelColumns list.
        // This drops any old saved definitions like Discussion 3 / Followup Date 4, etc.
        const mergedColumns = excelColumns.map((col) => {
          const saved = savedColumns.find(
            (sCol) => sCol.column === col.column
          );
          return saved
            ? { ...col, isChecked: saved.isChecked }
            : col;
        });

        const checkedColumns = mergedColumns.filter((c) => c.isChecked);

        setColumns(mergedColumns);
        setSelectedColumns(checkedColumns);
      }
    } catch (error) {
      setColumns(excelColumns);
      console.log("Failed to fetch columns data");
    }
  };
  React.useEffect(() => {
    if (excelKey) {
      fetchColumns(excelKey);
    }
  }, [excelKey]);

  // const handleChange = (event, columnIndex) => {
  //   const newColumns = [...columns];
  //   newColumns[columnIndex].isChecked = event.target.checked;
  //   setColumns(newColumns);
  // };

  const handleChange = (event, columnIndex) => {
    const newColumns = [...columns];
    newColumns[columnIndex].isChecked = event.target.checked;
    setColumns(newColumns);

    const updatedSelectedColumns = [...selectedColumns];
    const selectedColumn = columns[columnIndex];

    if (event.target.checked) {
      // Add the whole column object if checked and maintain order of selection
      updatedSelectedColumns.push(selectedColumn);
    } else {
      // Remove the whole column object if unchecked
      const indexToRemove = updatedSelectedColumns.findIndex(
        (col) => col.column === selectedColumn.column
      );
      if (indexToRemove > -1) {
        updatedSelectedColumns.splice(indexToRemove, 1);
      }
    }

    setSelectedColumns(updatedSelectedColumns);
  };

  const getAllDates = (dates) => {
    const [startDate, endDate] = dates.map((date) => new Date(date));
    const dateArr = [];
    const formatDate = (date) => {
      let year = date.getFullYear();
      let month = (date.getMonth() + 1).toString().padStart(2, "0");
      let day = date.getDate().toString().padStart(2, "0");
      return `${year}-${month}-${day}`;
    };
    let currentDate = new Date(startDate);
    if (endDate === undefined) {
      dateArr.push(formatDate(currentDate));
      return dateArr;
    } else {
      while (currentDate <= endDate) {
        dateArr.push(formatDate(currentDate));
        currentDate.setDate(currentDate.getDate() + 1);
      }
      return dateArr;
    }
  };
  const handleListItemClick = async () => {
    try {
      if (selectedColumns.length === 0) {
        console.log("Please Select Columns....");
        return;
      }

      let dateArr;
      if (selectedType === "Custom") {
        dateArr = getAllDates(selectedDates);
      } else {
        dateArr = selectedDates;
      }

      const data = {
        dateArr: dateArr.join(","), // Joining the dates as a comma-separated string
        columns: selectedColumns,
        selectedType: selectedType,
        excelKey: excelKey,
        category: category,
      };
      if (selectedType === "All") {
        data.dateForm = "all";
      } else {
        data.dateForm = "filtered";
      }
      const url = `${process.env.REACT_APP_NODE_URL}/api/generate/setup-excel`;
      const token = await localStorage.getItem("rbacToken");
      const config = {
        headers: {
          token: token ? token : "",
        },
        responseType: "arraybuffer",
      };
      setLoading(true);
      const response = await axios.post(url, data, config);

      const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
        timeZone: "Asia/Kolkata",
      };

      const currentDate = new Date();
      const formattedDate = new Intl.DateTimeFormat("en-GB", options)
        .format(currentDate)
        .replace(/(\d{2})\/(\d{2})\/(\d{4}), (\d{2}):(\d{2})/, "$3$2$1_$4$5");

      const filename = `${selectedType}_${excelKey}_${formattedDate}.xlsx`;

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link); // Append to the DOM
      link.click(); // Trigger the download
      document.body.removeChild(link); // Clean up

      await fetchColumns(excelKey);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
    onClose();
  };

  return (
    <Modal show={open} onHide={onClose} size="lg" centered>
      <Modal.Body
        style={{
          padding: "1rem",
          fontSize: "0.85rem", // Smaller font size for compact design
        }}
      >
        <span
          style={{
            fontSize: "16px",
            fontWeight: "bold",
            color: "#4682B4",
            marginBottom: "5px",
            display: "block",
          }}
        >
          Select Excel Columns
        </span>
        <div style={{ width: "100%" }}>
          <ul
            style={{
              padding: 0,
              margin: 0,
              listStyleType: "none",
              display: "grid",
              gridTemplateColumns: "auto auto auto auto",
            }}
          >
            {columns.map((column, index) => (
              <li
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "0.5rem",
                }}
              >
                <input
                  type="checkbox"
                  checked={column.isChecked}
                  onChange={(e) => handleChange(e, index)}
                  aria-label="controlled"
                  style={{
                    marginRight: "0.5rem",
                    accentColor: "#4682B4",
                  }}
                />
                <span style={{ fontSize: "12px", color: "#797d7f" }}>
                  {column.name}
                </span>
              </li>
            ))}
          </ul>
        </div>
        <div className="d-flex justify-content-end">
          {/* Action Buttons */}
          <button
            className="btn btn-outline-secondary rounded-pill px-4 me-3"
            onClick={onClose}
            style={{ fontSize: "0.9rem" }}
          >
            Cancel
          </button>
          <button
            className="btn btn-info text-white rounded-pill px-4 py-2"
            onClick={handleListItemClick}
            style={{ fontSize: "0.9rem" }}
          >
            {loading ? (
              <div className="d-flex justify-content-between align-items-center">
                <Spinner
                  animation="border"
                  size="sm"
                  style={{
                    width: "20px",
                    height: "20px",
                  }}
                />
                <span className="ms-2">Processing</span>
              </div>
            ) : (
              <span>Download</span>
            )}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default function SimpleDialogDemo({
  selectedType,
  selectedDates,
  excelKey,
  category,
  excelColumns,
}) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (value) => {
    setOpen(false);
  };

  return (
    <div>
      <Tooltip title={"Setup Excel"}>
        <button
          className="btn btn-danger d-flex align-items-center gap-2"
          onClick={handleClickOpen}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="currentColor"
            className="bi bi-box-arrow-in-down"
            viewBox="0 0 16 16"
          >
            <path
              fillRule="evenodd"
              d="M3.5 6a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 1 0-1h2A1.5 1.5 0 0 1 14 6.5v8a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 14.5v-8A1.5 1.5 0 0 1 3.5 5h2a.5.5 0 0 1 0 1z"
            />
            <path
              fillRule="evenodd"
              d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z"
            />
          </svg>
          Excel
        </button>
      </Tooltip>
      <SimpleDialog
        open={open}
        onClose={handleClose}
        selectedDates={selectedDates}
        selectedType={selectedType}
        excelKey={excelKey}
        category={category}
        excelColumns={excelColumns}
      />
    </div>
  );
}
